<template>
  <div class="content_usersetting mg_bot50 clearfix" id="user_trading_settings">

    <div class="filter_container clearfix">
      <div class="clearfix col-xs-4 market-select-area">
        Disable BTCUSD Fee (ON is disable fee)
        <label class="switch">
          <input type="checkbox" v-model="isDisableFee" @click="changeFeeStatus">
          <span>
            <i></i>
          </span>
        </label>
      </div>

      <div class="search_box form-group col-xs-6">
        <input type="text" placeholder="Search" v-on:keyup.enter="search" @keyup="debounceSearch" class="form-control search_input" name="searchKey" v-model="searchKey"/>
      </div>

      <div class="clearfix"></div>

    </div>

    <div class="row">
      <div class="col-xs-6 col-sm-5 col-left-user">
        <div class="box_table_UserSetting_right">
          <table class="table table_UserSetting_right " :class="balancesDefault ? 'table_hover' :''" :limit="10" :column="8">
            <thead>
            <tr>
              <th class="text-left" >{{ $t('enable_trading.no') }}</th>
              <th class="text-left" >{{ $t('enable_trading.contract') }}</th>
              <th class="text-left">{{ $t('enable_trading.title') }}</th>
              <th class="text-left">{{ $t('enable_trading.show_beta_tester') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, key) in contractList" :key="key" @click="getDataUserTable(item)" :class="{'active': item.symbol == selectedSymbol}">
              <td class="text-left">
                <div>{{ key + 1 }}</div>
              </td>
              <td class="text-left">
                {{ (item.symbol || '--') | uppercase }}
              </td>
              <td class="text-left">
                <button class="btn"
                  :class="item.is_enable ? 'btn_enable' : 'btn_disable'"
                  @click.stop="onClickedUpdateContractSetting(item)">
                  {{ item.is_enable ? $t('common.action.enable') : $t('common.action.disable') }}
                </button>
              </td>
              <td class="text-left">
                <button :disabled="item.is_enable == 1" class="btn"
                  :class="item.is_show_beta_tester ? 'btn_enable' : 'btn_disable'"
                  @click.stop="onClickedUpdateShowBetaTester(item)">
                  {{ item.is_show_beta_tester ? $t('common.action.enable') : $t('common.action.disable') }}
                </button>
              </td>
            </tr>
            </tbody>
          </table>


        </div>
      </div>

      <div class="col-xs-6 col-sm-7 col-right-user">
        <div class="datatable box_UserSetting_right">
          <data-table :getData="getData" :totalUser="numberOfUser" ref="datatable" :limit="10" :column="5" class="scroll height-custom">
            <th class="text-left cl_170" data-sort-field="email">{{ $t('user.email') }}</th>
            <th class="text-left cl_110">{{ $t('enable_trading.mam_user') }}</th>
            <th class="text-left cl_120">{{ $t('enable_trading.is_beta_tester') }}</th>
            <th class="text-left cl_90">
              {{ $t('enable_trading.status') }}
            </th>
            <th class="text-center cl_170">
              <button @click="addAccount()" class="btn btn-add" :disabled="!selectedSymbol">
                <i class="icon-plus"></i>
                {{ $t('account_setting.add_user') }}
              </button>
            </th>

            <template slot="body" slot-scope="props">
              <tr>
                <td class="text-left font14">
                  <div class="item_email_setting font14">
                    <span class="txt_email_setting font14">{{ props.item.email }}</span>
                    <span class="tooltip_email_setting font14">{{ props.item.email }}</span>
                  </div>
                </td>
                <td class="text-left font14">{{ props.item.is_mam ? $t('common.action.yes') : $t('common.action.no') }}</td>
                <td class="text-left font14">{{ props.item.is_beta_tester ? $t('common.action.yes') : $t('common.action.no') }}</td>
                <td class="text-left cl_170">
                  <button class="btn"
                    :class="props.item.status == 'enable' ? 'btn_enable' : 'btn_disable'"
                    @click.stop="onClickedUpdateUserSetting(props.item)">
                    {{ convertStatus(props.item.status) }}
                  </button>
                </td>
                <td class="text-center">
                  <button class="btn btn-close-table" @click="confirmDeleteColumn(props.item)"><i class="icon-close2"></i></button>
                </td>

              </tr>
            </template>
          </data-table>
        </div>
      </div>

      <modal name="addUserEnableFee" width="450">
        <div slot="body" class="body-popup add-user-enable-fee">
          <div class="form-group-detail">


            <div class="group-detail-form-group">
              <label class="group-detail-form-label">{{ $t('airdrop_setting.email') }}</label>
              <input class="group-detail-form-value" maxlength="190"
                     id="input-airdrop-title" type="text" name= "email" v-model="newUser.email"
                     data-vv-validate-on=""
                     :data-vv-as="$t('email')" v-validate="'required|email'"
                     v-bind:class="{'error-modal': errors.has('email')}"
              />
              <div class="clearifx"></div>
              <div class="error-box">
                <span v-show="showErrorModal && errors.has('email')" class="f-left is-error">{{ errors.first('email') }}</span>
              </div>
              <div class="form-check">
                <input type="checkbox" v-model="newUser.isMam" id="isMam">
                <label class="form-check-label" for="isMam"> {{ $t('enable_trading.is_mam')}}</label>
              </div>
              <div class="form-check">
                <input type="checkbox" v-model="newUser.allContract" id="allContract">
                <label class="form-check-label" for="allContract"> {{ $t('enable_trading.all_contract')}}</label>
              </div>
            </div>

          </div>
        </div>

      </modal>

      <modal name="deleteUserEnableFee" width="450">
        <div slot="body" class="body-popup add-user-enable-fee">
          <div class="form-group-detail">
            <div class="group-detail-form-group">
              <label class="group-detail-form-label-1">{{ $t('airdrop_setting.confirm_remove') }}</label>
              <div class="form-check" v-if='deletingUser.allContract'>
                <input type="checkbox" v-model="deletingUser.isMam" id="isMam">
                <label class="form-check-label" for="isMam"> {{ $t('enable_trading.remove_is_mam')}}</label>
              </div>
              <div class="form-check">
                <input type="checkbox" v-model="deletingUser.allContract" id="allContract">
                <label class="form-check-label" for="allContract"> {{ $t('enable_trading.remove_all_contract')}}</label>
              </div>
            </div>
          </div>
        </div>
      </modal>

    </div>
</div>
</template>

<script>
  import rf from '../../lib/RequestFactory';
  import BigNumber from 'bignumber.js';
  import Numeral from '../../lib/numeral';
  import SelectBox from '../../components/SelectBox';
  import Modal from "../../components/Modal";

  export default {
    components: {
      SelectBox,
      Modal,
    },
    data() {
      return {
        titlePage: this.$t('enable_trading.title'),
        searchKey: '',
        balancesDefault: false,
        numberOfUser: 0,
        contractList: [],
        selectedSymbol: null,
        hasError: false,
        showErrorModal: false,
        newUser: {},
        deletingUser: {},
        isDisableFee: false,
      }
    },
    methods: {
      async changeFeeStatus () {
        try {
          let res = await rf.getRequest('AdminRequest').updateFeeStatusSetting({ is_disable_fee: !this.isDisableFee});
          if (res && res.data) {
            this.isDisableFee = res.data.is_disable_fee;
            const message = res.data.is_disable_fee ? 'Disable Trading Fee Successfully!' : 'Enable Trading Fee Successfully!';
            this.$toastr('success', message);
          }
        } catch (e) {
          if (e.response.data.message) {
            this.$toastr('error', e.response.data.message);
          }
        }
      },
      convertStatus (item) {
        if (item == 'enable') {
          return window.i18n.t('common.action.enable')
        } else if (item == 'disable') {
          return window.i18n.t('common.action.disable')
        } else if (item == 'waiting') {
          return window.i18n.t('common.action.waiting')
        } else {
          return ''
        }
      },
      showModal (config) {
        const type = config.type;
        const title = config.title;
        const content = config.content;
        const customContent = config.customContent;

        let btnCancelLabel = config.btnCancelLabel || this.$t('common.action.no');
        let btnConfirmLabel = config.btnConfirmLabel || this.$t('common.action.yes');
        if (config.noAction) {
          btnCancelLabel = null;
          btnConfirmLabel = null;
        }
        const onConfirm = config.onConfirm;
        const onCancel = config.onCancel;

        window.ConfirmationModal.show({
          type: type,
          title: title,
          content: content,
          customContent: customContent,
          btnCancelLabel: btnCancelLabel,
          btnConfirmLabel: btnConfirmLabel,
          onConfirm: onConfirm,
          onCancel: onCancel
        });
      },

      search() {
        this.$refs.datatable.$emit('DataTable:filter', {
          symbol: this.selectedSymbol,
          search_key: this.searchKey
        });
      },
      debounceSearch: _.debounce(function() {
        this.$refs.datatable.$emit('DataTable:filter', {
          symbol: this.selectedSymbol,
          search_key: this.searchKey
        });
      },1500),

      getData(params) {
        if (params.search_key) {
          return this.getUserListFromContract(params);
        }

        if (params.symbol) {
          return this.getUserListFromContract(params);
        }

        return this.resetDataUserTable();
      },

      getDataUserTable(params) {
        this.$refs.datatable.$emit('DataTable:filter', params);
        this.search_key = '';
      },

      resetDataUserTable() {
        // this.$refs.datatable.refresh();
        return new Promise((resolve, reject) => {
          return resolve([]);
        });
      },

      getUserListFromContract(setting) {
        this.selectedSymbol = setting.symbol;

        let res = rf.getRequest('AdminRequest').getTradingSettings(setting)
          .then(res => {
            if (!res.data || !res.data.data) return res;

            window._.map(res.data.data, currenItem => {
              currenItem.symbol = setting.symbol;
              currenItem.isWrite = false;
              currenItem.isReset = false;
            });
            res.data.data = res.data.data.filter(currenItem=>currenItem.status!=='ignore');
            return res;
          });

        return res;
      },

      getContractSettingList(params) {
        return rf.getRequest('AdminRequest').getContractSettings(params)
          .then(res => {
            let newContractList = [];
            if (res.data) {
              newContractList = res.data;
            }
            this.contractList = newContractList;
            _.forEach(newContractList, (item) => {
              if (item.symbol == "BTCUSD") {
                this.isDisableFee = item.is_disable_fee;
              }
            });
            this.resetDataUserTable();
          });
      },

      addAccount() {
        this.showErrorModal = false;
        this.errors.clear();
        this.newUser = {};

        CommonModal.show("addUserEnableFee", {
          position: "add-group customModal",
          mask: true,
          buttons: [
            {
              label: this.$t('common.action.cancel'),
              focused: true,
              style: {
                width: "140px",
                background: "rgb(0, 112, 192)"
              },
              callback: () => {
                this.showErrorModal = false;
                CommonModal.hide("addUserEnableFee");
              }
            },
            {
              label: this.$t('common.action.save'),
              focused: true,
              style: {
                width: "140px",
                background: "rgb(0, 112, 192)"
              },
              callback: () => {
                let item = this.newUser;
                this.createNewUser(item);
              }
            }
          ]
        });

      },

      async createNewUser(item) {
        let isValid = await this.validateModal();
        this.showErrorModal = false;
        if (!isValid) {
          this.showErrorModal = true;
          return ;
        }

        let params = {
          email: item.email,
          symbol: this.selectedSymbol,
          allContract: item.allContract,
          is_mam: item.isMam ? 1 : 0
        }
        rf.getRequest('AdminRequest').addTradingSetting(params).then(res => {

            CommonModal.hide("addUserEnableFee");
            this.$toastr('success', window.i18n.t('common.alert.create.success'));
            this.newUser = {};
            this.search();
          })
          .catch(e => {
            if (e.response.data.message) {
              this.$toastr('error', e.response.data.message);
            }
          })
      },

      async validateModal() {
        this.errors.clear();
        await this.$validator.validate('email');

        if (this.errors.count() > 0) {
          return false;
        }
        return true;
      },

      confirmDeleteColumn(item) {
        CommonModal.show("deleteUserEnableFee", {
          position: "add-group customModal",
          mask: true,
          buttons: [
            {
              label: this.$t('common.action.no'),
              focused: true,
              style: {
                width: "140px",
                background: "rgb(0, 112, 192)"
              },
              callback: () => {
                this.showErrorModal = false;
                CommonModal.hide("deleteUserEnableFee");
              }
            },
            {
              label: this.$t('common.action.yes'),
              focused: true,
              style: {
                width: "140px",
                background: "rgb(0, 112, 192)"
              },
              callback: () => {
                this.deleteColumn(item);
              }
            }
          ]
        });
      },

      deleteColumn(item) {
        if ( (this.itemUser) &&item.user_id == this.itemUser.user_id) {
          this.itemUser = null;
          this.currentUser = false;
        }
        let params = {
          ...item,
          allContract: this.deletingUser.allContract,
          is_mam: this.deletingUser.isMam ? 1 : 0,
        }
        rf.getRequest('AdminRequest').deleteTradingSetting(params).then(res =>{
            this.search();
            this.$toastr('success', window.i18n.t('enable_trading.remove_success'));
            CommonModal.hide("deleteUserEnableFee");
          })
          .catch(ex => {
            console.log(ex);
            this.$toastr('error', window.i18n.t('enable_trading.remove_fail'));
          });
      },

      onClickedUpdateUserSetting(setting) {
        const title = setting && setting.status == 'enable' ?
                        this.$t('enable_trading.user_setting.confirm_off') :
                        this.$t('enable_trading.user_setting.confirm_on');
        let params = {
            ...setting,
            'status': setting.status == 'enable' ? 'disable' : 'enable',
        };

        this.showModal({
          type: 'confirm',
          title: title,
          onConfirm: () => {
            rf.getRequest('AdminRequest').updateTradingSetting(params)
            .then(res => {
              setting.status = setting.status == 'enable' ? 'disable' : 'enable'
              setting.is_beta_tester = res.data.is_beta_tester
              this.$toastr('success', window.i18n.t('enable_trading.user_setting.update_success'));
            }).catch(e => {
              this.$toastr('error', window.i18n.t('enable_trading.user_setting.update_fail'));
            });
          }
        });
      },

      onClickedUpdateContractSetting(setting) {
        const title = setting && setting.is_enable ?
                        this.$t('enable_trading.user_setting.confirm_off') :
                        this.$t('enable_trading.user_setting.confirm_on');
        let params = {
            ...setting,
            'is_enable': !setting.is_enable,
        };

        this.showModal({
          type: 'confirm',
          title: title,
          onConfirm: () => {
            rf.getRequest('AdminRequest').updateContractSetting(params)
            .then(res => {
              setting.is_enable = !setting.is_enable;
              if (setting.is_enable) {
                setting.is_show_beta_tester = false;
              }
              this.$toastr('success', window.i18n.t('enable_trading.user_setting.update_success'));
            }).catch(e => {
              this.$toastr('error', window.i18n.t('enable_trading.user_setting.update_fail'));
            });
          }
        });
      },

      onClickedUpdateShowBetaTester(setting) {
        const title = setting && setting.is_show_beta_tester ?
                        this.$t('enable_trading.user_setting.confirm_off') :
                        this.$t('enable_trading.user_setting.confirm_on');
        let params = {
            ...setting,
            'is_show_beta_tester': !setting.is_show_beta_tester,
        };

        this.showModal({
          type: 'confirm',
          title: title,
          onConfirm: () => {
            rf.getRequest('AdminRequest').updateContractSetting(params)
            .then(res => {
              setting.is_show_beta_tester = !setting.is_show_beta_tester;
              this.$toastr('success', window.i18n.t('enable_trading.user_setting.update_success'));
            }).catch(e => {
              this.$toastr('error', window.i18n.t('enable_trading.user_setting.update_fail'));
            });
          }
        });
      },

      initEmptyList() {
        let i = 0;
        this.contractList = [];
        while (i++ < 10) {
          this.contractList.push({});
        }
      },
      blockTabBrowser(e){
        if (e.key == 'Tab') {
          e.preventDefault();
        }
      },
    },
    created() {
      document.addEventListener('keydown', this.blockTabBrowser);
      this.getContractSettingList({});
    },
    beforeDestroy() {
      document.removeEventListener('keydown',this.blockTabBrowser);
    },
    mounted() {
      // this.initEmptyList();
      this.$emit('EVENT_PAGE_CHANGE', this);
    }
  }
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables";

  .switch {
    margin-bottom: 0px;
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    input {
      display:none;
      &:checked +span {
        background: $color-jungle-green;
        text-align: left;
        &:before {
          content: "ON";
          color: $color_white;
          font-size: 12px;
        }
        i {
          left: 35px;
        }
        &:after {
          content: " ";
          color: $color_white;
        }
      }

    }
    span {
      display: inline-block;
      padding: 0px 6px 0 9px;
      width: 54px;
      height: 20px;
      line-height: 20px;
      border-radius: 11px;
      background: $color_grey_icon_light;
      position: relative;
      color: $color_white;
      font-size: 14px;
      text-align: right;
      &:after {
        content: "OFF";
        color: $color_white;
        line-height: 20px;
        font-size: 12px;
      }
      i {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 100%;
        background: $color_white;
        position: absolute;
        left: 0;
        top: 0px;
        box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);
        -webkit-transition: all 0.3s ease-in-out;
        -moz-transition: all 0.3s ease-in-out;
        -ms-transition: all 0.3s ease-in-out;
        -o-transition: all 0.3s ease-in-out;
        transition: all 0.3s ease-in-out;
      }
    }
  }
  .cl_address {
    width: 350px;
  }
  .cl_50 {
    width: 50px;
  }
  .cl_110 {
    width: 110px;
  }
  .cl_90 {
    width: 90px;
  }
  .cl_120 {
    max-width: 140px;
  }
  .cl_140 {
    max-width: 140px;
  }
  .cl_170 {
    max-width: 170px;
  }
  .font14 {
    font-size: $font-root !important;
  }
  .status-enabled {
    color: $color-jungle-green;
  }
  .status-disabled {
    color: $color_alizarin_crimson;
  }
  .content_modal_withdrawSetting {
    color: $color_mine_shaft;
    font-size: 20px;
    font-weight: 500;
    text-align: center;
    line-height: $font_big_24;
  }
  .form-check {
    margin-top: 10px;
  }
  .form-check-label {
    color: #666666;
    font-weight: normal;
    font-family: $mulish-regular;
  }

  .content_usersetting {

    .btn_enable {
      background-color: transparent;
      text-transform: uppercase;
      width: 70px;
      height: 25px;
      line-height: 20px;
      padding: 0px 0px;
      text-align: center;
      font-size: $font-smaller;
      font-weight: 600;
      color: $color-caribbean-green;
      border: 1px solid $color-caribbean-green;
      border-radius: 3px;
      transition: 0.5s;
      &:hover {
        background-color: $color-aquamarine;
        border-color: $color-aquamarine;
        color: $color_white;
        transition: 0.5s;
      }
    }
    .btn_disable {
      background-color: transparent;
      text-transform: uppercase;
      width: 70px;
      height: 25px;
      line-height: 20px;
      padding: 0px 0px;
      text-align: center;
      font-size: $font-smaller;
      font-weight: 600;
      color: $color_alizarin_crimson;
      border: 1px solid $color_alizarin_crimson;
      border-radius: 3px;
      transition: 0.5s;
      &:hover {
        background-color: $color_alizarin_crimson;
        border-color: $color_alizarin_crimson;
        color: $color_white;
        transition: 0.5s;
      }
    }
    .btn_view {
      float: right;
      background-color: $color-caribbean-green;
      text-transform: uppercase;
      width: 55px;
      height: 25px;
      line-height: 20px;
      padding: 0px 9px;
      text-align: center;
      font-size: $font-smaller;
      font-weight: 600;
      color: $color-white;
      border: 1px solid $color-caribbean-green;
      border-radius: 3px;
      transition: 0.5s;
      &:hover {
        background-color: $color-aquamarine;
        border-color: $color-aquamarine;
        color: $color_white;
        transition: 0.5s;
      }
    }

    .filter_container {
      margin: 7px 0px 15px 0px;

      .title_item {
        color: $color-grey-dark;
        font-size: $font_root;
        font-family: $mulish-regular;
        font-weight: 500;
        line-height: 30px;
        float: left;
        margin-right: 11px;
      }
      .search_box {
        padding-right: 0px;
        display: inline-block;
        float: right;
        width: 215px;
        max-width: 100%;
        margin-bottom: 0px;
        color: $color-grey-dusty;
        font-family: $mulish-regular;
        .search_input {
          background-color: transparent;
          height: 28px;
          border: 1px solid $color_alto;
          padding: 4px 15px;
          line-height: 20px;
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: $font-small;
        }
      }
    }
    .btn_detail_user {
      float: right;
      background-color: transparent;
      text-transform: uppercase;
      width: 65px;
      height: 23px;
      line-height: 20px;
      padding: 0px 9px;
      text-align: center;
      font-size: $font-smaller;
      font-weight: 600;
      color: $color-jungle-green;
      border: 1px solid $color-caribbean-green;
      border-radius: 20px;
      margin-left: 15px;
      transition: 0.5s;
      &:hover {
        background-color: $color_corn;
        border-color: $color_corn;
        color: $color_white;
        transition: 0.5s;
      }
    }

    .item_email_setting {
      display: inline-block;
      position: relative;
      vertical-align: middle;
      .txt_email_setting {
        display: block;
        min-width: 130px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .tooltip_email_setting, .tooltip_address_setting {
        position: absolute;
        top: 0px;
        line-height: 20px;
        padding: 5px 20px;
        left: 100%;
        background-color: $color_white;
        white-space: nowrap;
        width: auto;
        z-index: 10;
        font-size: $font-smaller;
        font-weight: 500;
        color: $color_mine_shaft;
        transition: 0.5s;
        display: none;
        box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.4);
        &:after {
          right: 100%;
          top: 50%;
          border: solid transparent;
          content: " ";
          height: 0;
          width: 0;
          position: absolute;
          pointer-events: none;
          border-color: rgba(136, 183, 213, 0);
          border-right-color: $color_white;
          border-width: 5px;
          margin-top: -5px;
        }
      }
      &:hover {
        .tooltip_email_setting, .tooltip_address_setting {
          display: block;
          transition: 0.5s;
        }
      }
      .tooltip_address_setting {
        top: 100%;
        left: 0;
        &:after {
          left: 25%;
          bottom: 100%;
          top: initial;
          border-bottom-color: $color_white;
          border-right-color: transparent;
        }
      }
    }
  }

  @media only screen and (min-width: 1399px) {
     .content_usersetting .item_email_setting  .txt_email_setting {
        max-width: 250px;
     }
  }

  .box_table_UserSetting_right {
    min-height: 439px;
    background-color: $color_white;
    // max-height: 440px;
    overflow-y: auto;
    overflow-x: auto;
  }
  .box_UserSetting_right {
    // min-height: 440px;
    // background-color: $color_white;
  }
  .detail_balance {
    text-overflow: ellipsis;
    width: 150px;
    overflow: hidden;
    vertical-align: middle;
  }
  .detail_available_balance {
    text-overflow: ellipsis;
    width: 180px;
    overflow: hidden;
    vertical-align: middle;
  }


  .add-user-enable-fee {
    .is-error {
      color: $color_red_text !important;
    }
    .error-box {
      display: block;
      float: left;
      overflow: hidden;
      width: 100%;
      span {
        font-family: $mulish-regular !important;
      }
    }
  }

  .btn-add {
    height: 22px;
    border-radius: 3px;
    background-color: #B7FF03;
    border: 1px solid #B7FF03;
    font-size: $font_mini_mini;
    letter-spacing: 0.77px;
    color: #000000;
    text-align: center;
    padding: 1px 12px;
    padding-top: 2px;
    display: block;
    float: right;
    i {
      font-size: 8px;
      position: relative;
      top: 0px;
      margin-right: 4px;
    }
    &:hover {
      border-color: #C1FF28;
      background-color: #C1FF28;
    }
  }
  .btn-save-table,
  .btn-close-table,
  .btn-edit-table {
    width: 17px;
    height: 17px;
    text-align: center;
    line-height: 20px;
    padding: 0px;
    text-align: center;
    border: 0px;
    background-color: transparent;
    font-size: 16px;
    color: $color-jungle-green;
    margin-left: 7px;
    i {
      &:before {
        color: $color-jungle-green;
      }
    }
  }

  .form-group-detail {
    .group-detail-form-group {
      .group-detail-form-label{
        width: 100%;
        color: $color-grey-dusty;
        float: left;
        font-weight: normal;
        font-family: $mulish-regular;
        margin-bottom: 0px;
        margin-top: 10px;
      }
      .group-detail-form-label-1{
        width: 100%;
        margin-bottom: 30px;
        margin-top: 10px;
        line-height: 25px;
        text-align: center;
        font-size: 20px;
        color: rgb(42, 47, 50);
        font-family: "Roboto-Regular", sans-serif;
        font-size: 16px;
        font-weight: 600;
      }

      .group-detail-form-value {
        width: 100%;
        padding: 8px 16px;
        border: 1px solid #dee3eb;
        height: 35px;
        line-height: 35px;
        border-radius: 3px;
        font-family: $mulish-regular;
        // font-weight: 600;
        &:focus {
          border-color: $color-jungle-green;
        }
      }
      #input-airdrop-title {
        &.error-modal {
          border: solid 1px $color-red-main;
          border-radius: 3px;
        }
      }
      .textarea_input {
        height: 120px;
      }
    }
    .error-box {
      display: block;
      float: left;
      overflow: hidden;
      width: 100%;
      span {
        font-family: $mulish-regular !important;
      }
    }
    .is-error {
      color: #ff5252 !important;
    }
  }

  .filter_container {
    margin: 10px 0px 25px 0px;
    .title_item {
      color: $color_mine_shaft;
      font-size: $font_big;
      font-family: $mulish-regular;
    }
    .select-market {
      font-family: $mulish-regular;
      color: $color-grey-dark;
      font-size: $font-small;
      float: left;
    }
    .search_box {
      display: inline-block;
      float: right;
      width: 215px;
      max-width: 100%;
      .search_input {
        background-color: transparent;
        height: 28px;
        border: 1px solid $color_alto;
        padding: 4px 15px;
        line-height: 20px;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: $font-small;
      }
    }
  }

  .table_UserSetting_right {
    background-color: $color_white;
    margin: 0;

    thead {
      font-size: $font-small;
      th{
        position: relative;
        background-color: $color_white;
        line-height: 15px;
        font-weight: 500;
        color: $color_grey;
        padding: 5px 25px 4px 15px !important;
        border-bottom: 1px solid $color_alto;
        height: 38px;
        display: table-cell;
        vertical-align: inherit;
        font-family: $mulish-regular;
      }

    }
    tbody {
       tr {
        vertical-align: top;
        overflow-y: hidden;
        transition-property: height;
        transition-duration: 0.3s, 0.3s;
        transition-timing-function: ease, ease-in;
        height: auto;
        background-color: $color_white;
        &:last-child {
          td {
            .item_email_setting {
              vertical-align: middle;
              .tooltip_address_setting {
                top: inherit;
                bottom: 100%;
                &::after {
                  top: inherit;
                  bottom: -10px;
                  border-top-color: $color_white;
                  border-bottom-color: transparent;
                }
              }
            }
          }
        }

        td {
          height: 40px;
          overflow: initial;
          line-height: 23px;
          font-size: 14px !important;
          font-weight: 500;
          color: $color_mine_shaft;
          // padding: 8px 15px 4px 15px;
          border-top: 1px solid $color_catskill_white;
          font-family: $mulish-regular;
          vertical-align: middle;
          padding: 4px 8px;
        }
      }
    }

  }
  .text-bold-coin{
    text-overflow: ellipsis;
    width: 53px;
    overflow: hidden;
  }
  .text-bold-address{
    text-overflow: ellipsis;
    width: 320px;
    overflow: hidden;
    vertical-align: middle;
  }
  .text-bold-balance{
    text-overflow: ellipsis;
    width: 83px;
    overflow: hidden;
  }
  .text-bold-available-balance{
    text-overflow: ellipsis;
    max-width: 340px;
    overflow: hidden;
  }
  .market-select-area {
    padding-left: 0;
    .select-market-text {
      margin-right: 20px;
      color: #333333;
      font-size: 18px;
      font-family: "Mulish-Medium", sans-serif;
      line-height: 28px;
      float: left;
    }
  }

  .col-left-user {
    min-width: 330px;
  }
  .col-right-user {
    max-width: calc(100% - 330px);
  }

</style>


<style lang="scss">
@import "@/assets/sass/variables";
  #user_trading_settings {

    .customModal {
      height: auto;
      .modal-content {
        height: auto;
        .modal-body {
          padding: 0px 30px 15px 30px;
          .group-detail-form-label {
            margin-bottom: 5px;
          }
        }
        .modal-footer {
          padding-bottom: 30px;
        }
      }
    }
    .sc_search_select {
      .group_search_select {
        .button_drop_search {
          width: 80px;
          height: 30px !important;
          padding: 5px 10px 5px 10px !important;
          border-radius: 3px;
          font-size: $font-small;
          font-family: $mulish-regular;
          color: $color-grey-dark;
          i.icon-arrow1 {
            margin-left: 5px;
            color: $color_grey;
          }
          &:hover {
            border-color: $color-jungle-green;
            i.icon-arrow1 {
              color: $color-jungle-green;
            }
          }
        }
        .box_list_search_select {
          .list_search_select {
            li {
              font-family: $mulish-regular;
              font-size: $font-small;
              &:hover, &:active, &:focus {
                color: $color-jungle-green;
              }
            }
          }
        }
      }
    }
    tr:hover {
      background-color: #ececec;
      cursor: pointer;
    }
    tr {
      &.empty-data {
        &:hover {
          background-color: transparent;
          cursor: initial;
        }
        border-bottom: 1px solid transparent;
      }
      &.active {
        td {
          background-color: #d6efe9;
          border-top: 1px solid #d6efe9;
        }
        position: relative;
        &:after {
          border: solid transparent;
          content: " ";
          height: 0;
          width: 0;
          position: absolute;
          pointer-events: none;
          border-color: rgba(136, 183, 213, 0);
          border-left-color: #d6efe9;
          border-width: 20px;
          margin-top: 0px;
          right: -25px;
        }
      }
    }
    table {
      th {
        padding: 5px 10px 4px 15px !important;
      }
      tbody {
        td {
          padding: 5px 10px 4px 15px;
          .text-bold-coin {
            width: 30px;
          }
        }
      }
    }
  }
</style>
